// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TjzOE","placeholdersHeader":"styles_placeholdersHeader__2Hx7b","editorStyle":"styles_editorStyle__3tncL","placeholdersBox":"styles_placeholdersBox__1npbk"};